import React from 'react';
import { Button, Modal, Toast } from '@kaleyra/emmy';
import { useTranslation } from 'react-i18next';
import Styles from './index.module.scss';

export type BaseSeeMorePropsType = {
    visible: boolean;
    id: any;
    keyword: any;
    number_type: string;
};

export type DispatchPropsType = {
    onClose: () => void;
    onUpdatePublishStatus: (reqData: any, callback: (resp: any, flag: boolean) => void) => void;
    onLoad: () => void;
}

const PublishConfiguration: React.FC<BaseSeeMorePropsType & DispatchPropsType> = ({ onClose, onUpdatePublishStatus, visible, id, keyword, number_type, onLoad }) => {
    const { t } = useTranslation();

    const handlePublish = () => {
        onUpdatePublishStatus({ "keyword_id": id.id, status: keyword.status ? 0 : 1, meta_data:{number_type:number_type} }, deleteCallback);
    }

    const deleteCallback = (response: any, flag: boolean) => {
        if (response && flag) {
            onClose();
            Toast(response?.message, "success");
            onLoad();
        } else {
            Toast(response?.message, "error")
        }
    }

    const renderFooterBody = () => {
        return (
            <>
                <Button type="tertiary" onClick={() => { onClose() }}>{'Cancel'}</Button>
                <Button className={Styles.deleteBtn} type="danger" onClick={() => handlePublish()}>{`Yes, ${keyword.status ? 'Unpublish' : 'Publish'}`}</Button>
            </>
        )
    }

    return (
        <Modal
            visible={visible}
            title={`${keyword.status ? t('KLR03034') : t('KLR03035')}`}
            body={`${t('KLR03038')} ${keyword.status ? t('KLR03036') : t('KLR03037')} ${keyword.keyword || ""}`}
            footer={renderFooterBody()}
        />
    );
}

export default PublishConfiguration;

